import { Component, OnInit, Input } from '@angular/core';
import {File} from '@app/models/content';
import {TopicVal} from '@app/shared/enums';

@Component({
  selector: 'app-presentation',
  templateUrl: './presentation.component.html',
  styleUrls: ['./presentation.component.scss']
})
export class PresentationComponent implements OnInit {

  @Input() file: File;

  ngOnInit() {
    this.file.url = this.computeUrl(this.file);
    if (this.file.children) {
      this.file.children.forEach(file => {
        file.url = this.computeUrl(file);
      });
    }
  }

  computeUrl(file: File) {
    return '/bv/' +
      (file.topic.startsWith('revision') ? 'revisions' : TopicVal[file.topic]
        + '/' + file.slug + '-' + file.code);
  }
}
